module.exports = "<p>\r\n  ecommerce-header-style7 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/ecommerce-header-style7/ecommerce-header-style7.component.html
// module id = ./src/app/features/headers-styles/ecommerce-header-style7/ecommerce-header-style7.component.html
// module chunks = main